import styled from 'styled-components'
import colors from './colors'
import ReactSelect from 'react-select'
import Button from '../components/Button'

export const ReportsStyledButton = styled(Button)`
  margin-top: 5%;
  width: 43%;
`
export const ReportsTextArea = styled.textarea`
  max-width: 34vw;
  min-width: 97.5%;
  min-height: 50px;
  margin: 5px 0;
  border: ${(props) => (props.disabled ? 'none' : '1px solid #ddd')};
  font-size: 14px;
  font-weight: 100;
  padding: 10px 15px;
  border-radius: 4px;
  height: 46px;
  box-sizing: border-box;
  &:disabled {
    background: #ebebe4;
  }
  &:read-only {
    background: ${colors.readOnly};
  }
  &:focus {
    outline: 2px solid ${colors.monza};
    box-shadow: 0 0 0 1px ${colors.monza};
  }
`

export const ReportsInput = styled.input`
  min-width: 97.5%;
  margin: 5px 0;
  border: ${(props) => (props.disabled ? 'none' : '1px solid #ddd')};
  font-size: 14px;
  font-weight: 100;
  padding: 10px 15px;
  border-radius: 4px;
  height: 46px;
  box-sizing: border-box;
  &:disabled {
    background: #ebebe4;
  }
  &:read-only {
    background: ${colors.readOnly};
  }
  &:focus {
    outline: 2px solid ${colors.monza};
    box-shadow: 0 0 0 1px ${colors.monza};
  }
`
export const ReportsFormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: baseline;
  color: black;
  label,
  select {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  textarea {
    height: 7rem;
    width: 95%;
  }
  label {
    margin: 5px 0 0;
    font-weight: bold;
    font-size: 12px;
  }
`

export const ReportsStyledWrapper = styled.form`
  > h2 {
    font-size: 2em;
  }
`
export const ReportsStyledReactSelect = styled(ReactSelect)`
  width: 95%;
  margin: 5px 0;
`

export const ReportsSelectGridWrapper = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0;

  ${({ oneRow, dwoRows }) =>
    oneRow
      ? `
      grid-template-rows: 1fr;
      grid-template-areas: '. .';
     
  `
      : dwoRows
      ? `
      grid-template-rows: 1fr 1fr;
      grid-template-areas:
    '. .'
    '. .';
  `
      : ``}
`

export const ReportsHeader = styled.header`
  display: flex;
  background: var(--color-primary);
  color: var(--color-text);
  color: var(--color-background);
  > h1 {
    margin: 0;
    font-size: 2em;
    padding: 0.5rem;
  }
`
export const Hidden = styled.span`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
`
